module.exports = __webpack_public_path__ + "static/img/ruzhuImg.a729a693.png";